// In-AR element rotation. During an immersive-ar session Chrome pins
// the DOM to the session-start orientation, so when the phone
// physically rotates the DOM no longer faces the viewer. Containers
// stay put (pinned DOM == chassis coordinates), but each element
// rotates IN PLACE so its content reads upright from the viewer's
// current hold.
//
// physicalRotation comes from the DeviceOrientationEvent gamma signal
// (0 / 90 / 270; null until the first event). domRotation comes from
// screen.orientation.angle. Outside AR the DOM auto-rotates with the
// phone, so the two match and the delta is 0 — no gating on session
// state is needed.
//
// Returns the CSS rotation in degrees: 0, 90, or -90. The sign is the
// COUNTER-rotation: the pinned DOM appears rotated by `delta` to the
// viewer, so elements rotate by the opposite amount to net out
// upright. (Verified on-device 2026-07-10 — rotating WITH the delta
// rendered everything upside down.)
export function computeElementRotationDeg(
  physicalRotation: number | null,
  domRotation: number,
): number {
  if (physicalRotation == null) return 0
  const delta = (physicalRotation - domRotation + 360) % 360
  if (delta === 90) return -90
  if (delta === 270) return 90
  return 0
}
